import React, { Component } from 'react';
import Modal from 'react-modal'
import './Maintenance.css'
import { Icon, InlineIcon } from '@iconify/react';
import wrenchIcon from '@iconify/icons-simple-line-icons/wrench';

Modal.setAppElement('body');
class MaintenanceMessage extends Component {
    constructor() {
        super();
        this.state = {
            showModal: false,
            maintenancePlanned: '0',
            maintenanceMessage: '',
        };
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({
            showModal: false
        });
    }
    componentDidMount() {

        if (this.props.maintenancePlanned === '1') {
            fetch('properties/findByName?name=MaintenancePlannedMessage',{
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                return response.json()
            }).then(data => {
                this.setState({
                    maintenanceMessage: data.value
                })
            })
            this.handleOpenModal()
        }
    }
    render() {
        return (
            <div>
                <Modal className="maintenanceMessageModal" overlayClassName="Overlay maintenanceMessageModalOverlay" isOpen={this.state.showModal} onRequestClose={this.handleCloseModal}>
                    <div>
                        <div className='labelContainer'>
                        <Icon icon={wrenchIcon} className='icon' />
                        <p className='maintenance-label-text'>Maintenance notification:</p>

                        </div>
                  <div>
                  <p className='maintenanceMessageText'>{this.state.maintenanceMessage}</p>
                  </div>
                    

                    <div className='buttonContainer'>
                        <button id="close" className='forgoten-button-cancel' onClick={this.handleCloseModal}>Close</button>
                    </div>

                   </div>
                </Modal>
            </div>
        );
    }
}

export default MaintenanceMessage;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/MaintenanceMessage.js